const CargoItemAction = {
  IDLE: "IDLE",
  LOAD: "LOAD",
  UNLOAD: "UNLOAD"
};

export default CargoItemAction;
